/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/list/display.js ***!
  \*****************************/
window.addEventListener("DOMContentLoaded", event => {
  /* Apply a filter */
  const selectBoxes = document.querySelectorAll(".filters_form select");
  /* check that this works for several lsits on a page */
  const resultsDivs = document.querySelectorAll(".dspaceResourcesListBlock .resourcesOutputsWrapper");
  resultsDivs.forEach(function (resultsDiv) {
    const records = document.querySelectorAll(".resultsItem");
    selectBoxes.forEach(function (selectBox) {
      selectBox.addEventListener("change", function (evt) {
        resultsDiv.classList.add("faded");
        const filterVal = evt.target.value;
        records.forEach(function (record) {
          record.classList.remove("resourceHidden");
          const allterms = record.dataset.allterms.split(";");
          if (!allterms.includes(filterVal)) {
            record.classList.add("resourceHidden");
          }
        });
        setTimeout(function () {
          resultsDiv.classList.remove("faded");
        }, 750);
      });
    });
    addPagingListeners(resultsDiv, records.length);
  });

  /**  List view - open dialog **/
  const dialogBtns = document.querySelectorAll(".dialogOutputsMore");
  dialogBtns.forEach(function (el) {
    let identifier = el.data;
    el.addEventListener("click", function () {
      let identifier = el.dataset.identifier;
      document.getElementById("dialog" + identifier).showModal();
    });
  });

  /* Click on headers - list AND Cards view */
  const resourceHeaders = document.querySelectorAll(".dspaceResourcesListBlock .dspaceConnectTitle, .resourceThumb");
  resourceHeaders.forEach(function (el) {
    // console.log('list or trend?')
    el.addEventListener("click", function (e) {
      const parnt = el.closest(".resourceItemRecord");
      if (parnt) {
        if (parnt.classList.contains("list")) {
          const detals = parnt.querySelector("details");
          if (detals) {
            if (detals.open == false) {
              detals.open = true;
            } else {
              detals.open = false;
            }
          }
        } else {
          const dilog = parnt.querySelector("dialog");
          if (dilog) {
            dilog.showModal();
            const innerDetails = dilog.querySelector('details');
            if (innerDetails.open) {
              console.log('the dialog is open already');
            }
            if (innerDetails) {
              innerDetails.open = true;
            }
          }
        }
      }
    });
  });

  /** Switch between list and card views **/
  /** assumes only one instance per page **/
  const switchViews = document.querySelectorAll(".displaySwitcherOpt");
  switchViews.forEach(function (el) {
    el.addEventListener("click", function () {
      const swtype = el.dataset.switch;
      const fromtype = swtype === "list" ? "cards" : "list";
      const elsToSwitch = document.querySelectorAll(".switchLayoutsSel");
      const dialogsToSwitch = document.querySelectorAll(".dialogDetails");
      const detailsToSwitch = document.querySelectorAll(".outputDetails");
      elsToSwitch.forEach(function (elToSwitch) {
        elToSwitch.classList.remove(fromtype);
        elToSwitch.classList.add(swtype);
      });
      detailsToSwitch.forEach(function (detToSwitch) {
        if (swtype === "cards") {
          detToSwitch.setAttribute("open", "open");
        } else {
          detToSwitch.removeAttribute("open");
        }
      });
      dialogsToSwitch.forEach(function (diaToSwitch) {
        if (swtype === "cards") {
          diaToSwitch.close();
        } else {
          diaToSwitch.show();
        }
      });
    });
  });

  /*-----------------------------------------
  /* Paging listeners
  /*-----------------------------------------*/
  /* let resultsSections = document.querySelectorAll(".wp-block-dspace-ouptuts-dspace-connect");
  resultsSections.forEach(function(resultsSection) { 
      let pagingSections = resultsSection.querySelectorAll(".resourcesPagerSection");
  
      if (pagingSections[0]) {
        // console.log(pagingSection);
        const totalRecords = parseInt(pagingSections[0].dataset.totalrecs);
        const pagingNum = parseInt(pagingSections[0].dataset.pagenum);
  
        const pagingNavs = resultsSection.querySelectorAll(".resPageNav");
  
        pagingNavs.forEach(function(pagingNav) {
  
          pagingNav.addEventListener("click", function (evt) {
            const resBtnPrevs = resultsSection.querySelectorAll(".resPagePrev");
            const resPageNexts = resultsSection.querySelectorAll(".resPageNext");
            const padingDir = pagingNav.dataset.pagedir;
            const pagingLowNum = parseInt(resBtnPrevs[0].dataset.pagelow);
            let pagingNewLow;
            if (padingDir === "next") {
              pagingNewLow = pagingLowNum + pagingNum;
            }
            else {
              pagingNewLow = pagingLowNum - pagingNum;
            }
            let pagingNewHigh = pagingNewLow +pagingNum;
            if (pagingNewHigh >= totalRecords) { 
              pagingNewHigh = totalRecords;
              resPageNexts.forEach(function(resPageNext) {
                resPageNext.classList.add("navBtnHidden")
              })
            }
            else {
              resPageNexts.forEach(function(resPageNext) {
              resPageNext.classList.remove("navBtnHidden")
              });
            }
  
  
            if (pagingNewLow <= 0) { 
              padingNewLow = 0;
  
              resBtnPrevs.forEach(function(resBtnPrev) {
                resBtnPrev.classList.add("navBtnHidden")
                
              });
              
            } 
            else 
            {        
              resBtnPrevs.forEach(function(resBtnPrev) {
  
                resBtnPrev.classList.remove("navBtnHidden")
              });
            }
            resBtnPrevs[0].dataset.pagelow = pagingNewLow;
            resBtnPrevs[1].dataset.pagelow = pagingNewLow;
          
            const records = document.querySelectorAll(".resourceItemRecord");
            const lowValues = resultsSection.querySelectorAll('.resPageFrom'); 
            const highValues = resultsSection.querySelectorAll('.resPageTo'); 
  
  
            lowValues.forEach(function(lowValue) {
              lowValue.textContent = pagingNewLow+1;
            });
            highValues.forEach(function(highValue) {
              highValue.textContent = pagingNewHigh;
            });
            records.forEach(function(record, index){
  
              if (index >= pagingNewLow && index < pagingNewHigh) {
        
                record.classList.remove("resourceHidden");
              }
              else {
        
                record.classList.add("resourceHidden");
              }
          
            });
  
  
  
          });
        });
      }
  });*/

  /*--------------------------------------
  /*  Vertical filters
  ----------------------------------------*/

  let resourcesLeftFilters = document.querySelector('.filters_form_vertical');
  if (resourcesLeftFilters) {
    filterOpts = resourcesLeftFilters.querySelectorAll("input");
    filterOpts.forEach(function (fltEl) {
      fltEl.addEventListener('change', function (clickSubmit) {
        /* previously used 'searchShown'*/

        let resourcesContainer = resourcesLeftFilters.closest(".dspaceResourcesListBlock");
        resourcesContainer.classList.add("resourcesFiltered");
        const resultsDiv = resourcesContainer.querySelector('.resourcesOutputsInnerWrapper');
        const nearestForm = fltEl.closest(".filters_form_vertical");
        let recordsToSearch = document.querySelectorAll(".resourceItemRecord");
        if (nearestForm) {
          let formData = new FormData(nearestForm);

          /*Show matching */

          if (Array.from(formData.keys()).length > 0) {
            /* Hide all */
            recordsToSearch.forEach(recItem => {
              recItem.classList.add('filterHidden');
              recItem.classList.remove('resourceHidden');
            });
            for (const row of formData.entries()) {
              if (row[1] === "") {
                return;
              }
              const searchTerm = row[1].toLowerCase();
              if (searchTerm && searchTerm !== "") {
                let i = 0;
                recordsToSearch.forEach(recItem => {
                  const itemTerms = recItem.dataset.allterms;
                  let itemTermsArr = itemTerms.split(";");
                  let itemTermsArray = itemTermsArr.filter(function (el) {
                    return el != "";
                  });
                  let titleAbst = "";
                  const title = recItem.querySelector('.dspaceConnectTitle');
                  if (title) {
                    titleAbst += title;
                  }
                  let abstract = recItem.querySelector('.dspaceConnectAbstract');
                  if (abstract) {
                    const absText = " " + abstract.textContent;
                    titleAbst += absText;
                  }
                  if (itemTermsArr.some(element => {
                    return element.toLowerCase() === searchTerm;
                  })) {
                    recItem.classList.remove('filterHidden');
                    i++;
                  } else if (titleAbst.toLowerCase().includes(searchTerm)) {
                    recItem.classList.remove('filterHidden');
                    i++;
                  }
                });
                createPaging(resultsDiv, i);
                displayAmountText(resultsDiv, i);
              }
            }
          } else {
            /* Hide all */
            recordsToSearch.forEach(recItem => {
              recItem.classList.remove('filterHidden');
            });
            resourcesContainer.classList.remove("resourcesFiltered");
            createPaging(resultsDiv, recordsToSearch.length);
            displayAmountText(resultsDiv, recordsToSearch.length);
          }
        }
      });
    });
  }

  /*------------------------------------------*/
  /* Clear vertical filters button             */
  /*------------------------------------------*/
  document.querySelectorAll('.cgConnect-clear-filters-vertical').forEach(function (clearBtn) {
    clearBtn.addEventListener('click', function () {
      let resourcesContainer = clearBtn.closest('.dspaceResourcesListBlock');
      if (!resourcesContainer) return;
      resourcesContainer.querySelectorAll('.filters_form_vertical .opinput').forEach(function (cb) { cb.checked = false; });
      let records = resourcesContainer.querySelectorAll('.resourceItemRecord');
      records.forEach(function (rec) { rec.classList.remove('filterHidden'); });
      resourcesContainer.classList.remove('resourcesFiltered');
      clearBtn.style.display = 'none';
      let resultsDiv = resourcesContainer.querySelector('.resourcesOutputsInnerWrapper');
      if (resultsDiv) {
        createPaging(resultsDiv, records.length);
        displayAmountText(resultsDiv, records.length);
      }
    });
  });

  /* Show vertical clear button when a checkbox is checked */
  document.querySelectorAll('.filters_form_vertical .opinput').forEach(function (cb) {
    cb.addEventListener('change', function () {
      let resourcesContainer = cb.closest('.dspaceResourcesListBlock');
      if (!resourcesContainer) return;
      let clearBtn = resourcesContainer.querySelector('.cgConnect-clear-filters-vertical');
      if (!clearBtn) return;
      let anyChecked = Array.from(resourcesContainer.querySelectorAll('.filters_form_vertical .opinput')).some(function (c) { return c.checked; });
      clearBtn.style.display = anyChecked ? '' : 'none';
    });
  });

  /*------------------------------------------*/
  /* Clear horizontal filters button (×)       */
  /*------------------------------------------*/
  document.querySelectorAll('.cgConnect-clear-filters-horizontal').forEach(function (clearBtn) {
    clearBtn.addEventListener('click', function () {
      let resourcesContainer = clearBtn.closest('.dspaceResourcesListBlock');
      if (!resourcesContainer) return;
      resourcesContainer.querySelectorAll('.filters_form select').forEach(function (sel) { sel.selectedIndex = 0; });
      let records = resourcesContainer.querySelectorAll('.resultsItem');
      records.forEach(function (rec) { rec.classList.remove('resourceHidden'); });
      clearBtn.style.display = 'none';
      let resultsDiv = resourcesContainer.querySelector('.resourcesOutputsWrapper');
      if (resultsDiv) {
        createPaging(resultsDiv, records.length);
        displayAmountText(resultsDiv, records.length);
      }
    });
  });

  /* Show horizontal clear button when any select is non-empty */
  document.querySelectorAll('.filters_form select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      let resourcesContainer = sel.closest('.dspaceResourcesListBlock');
      if (!resourcesContainer) return;
      let clearBtn = resourcesContainer.querySelector('.cgConnect-clear-filters-horizontal');
      if (!clearBtn) return;
      let anyActive = Array.from(resourcesContainer.querySelectorAll('.filters_form select')).some(function (s) { return s.value !== ''; });
      clearBtn.style.display = anyActive ? '' : 'none';
    });
  });

  /*------------------------------------------*/
  /* Citation - copy to clipboard             */
  /*------------------------------------------*/

  let citationElms = document.querySelectorAll('.citationDisplay');
  citationElms.forEach(citationElm => {
    citationElm.addEventListener('click', function (e) {
      let citationText = citationElm.textContent;
      const copied = copyTextToClipboard(citationText);
      if (copied) {
        let spanDiv = citationElm.querySelector('span');
        if (spanDiv) {
          spanDiv.classList.remove('dashicons-plus-alt');
          spanDiv.classList.add('dashicons-yes-alt');
          setTimeout(function () {
            spanDiv.classList.remove('dashicons-yes-alt');
            spanDiv.classList.add('dashicons-plus-alt');
          }, 2500);
        }
        let identifier = citationElm.dataset.identifier;
        let citationClicked = new cgConnectourceEvent('dspace_res_citation_item', identifier);
        citationClicked.sendEvent();
      }
    });
  });

  /*------------------------------------------*/
  /* All Citations for list - copy to clipboard             */
  /*------------------------------------------*/

  let citationListElms = document.querySelectorAll('.cgConnect_list_citations_btn');
  citationListElms.forEach(citationElm => {
    citationElm.addEventListener('click', function (e) {
      let citationText = citationElm.dataset.allcitations;
      const copied = copyTextToClipboard(citationText);
      if (copied) {
        let spanDiv = citationElm.querySelector('span');
        if (citationElm) {
          citationElm.classList.remove('dashicons-plus-alt');
          citationElm.classList.add('dashicons-yes-alt');
          setTimeout(function () {
            citationElm.classList.remove('dashicons-yes-alt');
            citationElm.classList.add('dashicons-plus-alt');
          }, 2500);
        }
        let citationClicked = new cgConnectourceEvent('dspace_res_citations_all', "All Citations copied");
        citationClicked.sendEvent();
      }
    });
  });
  async function copyTextToClipboard(textToCopy) {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(textToCopy);
        return true;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  /*-------------------------------------------------------------------------------------------------
  /*  Resources  / Search All (publications page above results) - Search all (search within, below)
  ----------------------------------------------------------------------------------------------------*/
  let resourcesSearchSubmit = document.querySelectorAll('.cgConnect-all-searchsubmit_unused');
  resourcesSearchSubmit.forEach(elmSubmit => {
    elmSubmit.addEventListener('click', function (e) {
      e.preventDefault();
      const searchType = searchForm.querySelector(".searchType");
      if (["sendbtn", "send"].includes(searchType.value)) {
        const formData = new FormData(searchForm);
        //debugger;

        return true;
      }
    });
  });
  const searchModifier = document.querySelector('.cgspSearchModifierGeneral');
  if (searchModifier) {
    addSearchBtnsListeners(searchModifier);
  }
  const searchFormText = document.querySelector('.cgConnect-searchinput.allsearch');
  if (searchFormText) {
    const parentNear = searchModifier.closest('.searchFormTop');
    const searchForm = parentNear.querySelector('form');
    searchFormText.addEventListener('click', function () {
      if (searchFormText.value.length > 0) {
        searchForm.submit();
      }
    });
  }

  /*------------------------------------------------------------------------*/
  /*   Switch search Criteria buttons - By Country, By Type, By Keyword     */
  /*------------------------------------------------------------------------*/

  function addSearchBtnsListeners(searchModifier) {
    const parentNear = searchModifier.closest('.searchFormTop');
    const searchForm = parentNear.querySelector('form');
    const searchBtnModifiers = parentNear.querySelectorAll('.cgspSearchModifierGeneral');
    searchBtnModifiers.forEach(function (searchBtnCtrl) {
      searchBtnCtrl.addEventListener('click', function (evt) {
        searchBtnModifiers.forEach(function (searchBtnA) {
          searchBtnA.classList.remove('selectedOpt');
        });
        const clickedElm = evt.target;
        let selectorField = searchForm.querySelector('.resourcesSearchCriteria');
        selectorField.value = clickedElm.dataset.modifier;
        clickedElm.classList.add('selectedOpt');
        const inputField = searchForm.querySelector('.cgConnect-searchinput');
        if (inputField) {
          let modifierText = clickedElm.dataset.modifier;
          modifierText = modifierText.charAt(0).toUpperCase() + modifierText.slice(1);
          if (modifierText === "Country") {
            modifierText = "Country / Region";
          }
          const placholderText = "Search by  " + modifierText;
          inputField.placeholder = placholderText;
          inputField.classList.add('updatedPlaceholder');
          setTimeout(function () {
            inputField.classList.remove('updatedPlaceholder');
          }, 5000);
        }
      });
    });
  }

  /*------------------------------------------------------------------------------------------------
  /*  Resources in-page search / Search within
  --------------------------------------------------------------------------------------------------------*/
  /* Treat like a filter --- using filterHidden */
  let resourcesResultsSearchSubmit = document.querySelectorAll('form.resourcesResultsSearch:not(.send)');
  resourcesResultsSearchSubmit.forEach(nearestForm => {
    nearestForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const nearestResourceContainer = nearestForm.closest(".dspaceResourcesListBlock");
      const resultsDiv = nearestResourceContainer.querySelector(".resourcesDisplaySection");
      let searchCount = 0;
      if (nearestForm) {
        let formData = nearestForm.elements;
        const searchTerm = formData["resourcesResultsSearchInpt"].value.toLowerCase();
        if (searchTerm && searchTerm !== "") {
          let recordsToSearch = document.querySelectorAll(".resourceItemRecord");
          recordsToSearch.forEach(recItem => {
            recItem.classList.add('filterHidden');
            let itemTerms = recItem.dataset.allterms;
            let title = recItem.querySelector('.dspaceConnectTitle');
            if (title) {
              const titleText = " " + title.textContent;
              itemTerms += titleText;
            } else {
              console.log('no title ');
            }
            let abstract = recItem.querySelector('.dspaceConnectAbstract');
            if (abstract) {
              const absText = " " + abstract.textContent;
              itemTerms += absText;
            }
            if (itemTerms.toLowerCase().includes(searchTerm)) {
              recItem.classList.remove('filterHidden');
              searchCount++;
            }
          });
          if (searchCount === 0) {
            let clearSearch = document.querySelector('.clearSearchElm');
            if (clearSearch) {
              clearSearch.classList.remove('hidden');
              clearSearch.addEventListener('click', function () {
                recordsToSearch.forEach(recItem => {
                  recItem.classList.remove('filterHidden');
                });
                clearSearch.classList.add('hidden');
              });
            }
          }
        } else {
          console.log('nothing searched for');
        }
      }
      createPaging(resultsDiv);
      displayAmountText(resultsDiv, searchCount);
    });
  });
  let resourcessortSubmit = document.querySelectorAll('.resources_sortSelect');
  resourcessortSubmit.forEach(resSort => {
    const nearestResourceContainer = resSort.closest(".dspaceResourcesListBlock");
    //console.log(nearestResourceContainer);
    const resultsDiv = nearestResourceContainer.querySelector(".resourcesDisplaySection");
    const nearestResults = nearestResourceContainer.querySelector(".resourcesOutputsInnerWrapper");
    const resultsArray = resultsDiv.querySelectorAll(".resourceItemRecord");
    resSort.addEventListener("change", function (evt) {
      evt.preventDefault();
      /*Show matching */
      const typeSort = evt.target.value.toLowerCase();
      function sortTitle(a, b) {
        if (a.dataset.sorttitle < b.dataset.sorttitle) {
          return -1;
        }
        if (a.dataset.sorttitle > b.dataset.sorttitle) {
          return 1;
        }
        return 0;
      }
      function sortDate(a, b) {
        if (a.dataset.sortdate < b.dataset.sortdate) {
          return -1;
        }
        if (a.dataset.sortdate > b.dataset.sortdate) {
          return 1;
        }
        return 0;
      }
      function sortType(a, b) {
        if (a.dataset.sorttype < b.dataset.sorttype) {
          return -1;
        }
        if (a.dataset.sorttype > b.dataset.sorttype) {
          return 1;
        }
        return 0;
      }
      let sortItems;
      // Sort the array by age in ascending order
      if (typeSort === "sorttitle") {
        sortItems = Array.from(resultsArray).sort(sortTitle);
      } else if (typeSort === "sortdate") {
        sortItems = Array.from(resultsArray).sort(sortDate);
      } else if (typeSort === "sorttype") {
        sortItems = Array.from(resultsArray).sort(sortType);
      }
      sortItems.forEach(item => nearestResults.appendChild(item));
      createPaging(resultsDiv);
    });
  });
  let resourcesReverse = document.querySelectorAll('.resultsReverse');
  resourcesReverse.forEach(resSort => {
    resSort.addEventListener("click", function (evt) {
      evt.target.classList.toggle('opposite');
      const nearestResourceContainer = resSort.closest(".dspaceResourcesListBlock");
      const resultsDiv = nearestResourceContainer.querySelector(".resourcesDisplaySection");
      const nearestResults = nearestResourceContainer.querySelector(".resourcesOutputsInnerWrapper");
      const resultsArray = nearestResults.querySelectorAll(".resourceItemRecord");
      const reverseItems = Array.from(resultsArray).reverse();
      reverseItems.forEach(item => nearestResults.appendChild(item));
      createPaging(resultsDiv);
    });
  });

  /* following functions also present in search/display.js */
  function createPaging(resultsDiv, totalRecords = 0) {
    let pagingAmt = resultsDiv.dataset.pagingnumber;
    if (pagingAmt === "") {
      return;
    }
    if (totalRecords === 0) {
      const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");
      totalRecords = records.length;
    }
    const resultsParent = resultsDiv.closest(".dspaceResourcesListBlock");
    if (resultsParent) {
      const existingPagers = resultsParent.querySelectorAll('.resourcesPagerSection');
      existingPagers.forEach(function (pager) {
        pager.remove();
      });
    }
    console.log(`total records at create paging is ${totalRecords}`);
    let pagingAmountNum = parseInt(pagingAmt);
    if (pagingAmountNum == 0 || pagingAmountNum >= totalRecords) {
      /* console.log ('No paging');*/
      const resourcesPagerSection = createCustomElement("div", {
        "class": ["resourcesPagerSection"]
      }, {
        "data-totalrecs": "20",
        "data-pagenum": pagingAmt
      });
      const numberRecordsDisplay = createCustomElement("div", {
        "class": ["numberRecordsDisplay"]
      }, {}, "Total " + totalRecords + " records");
      resourcesPagerSection.append(numberRecordsDisplay);
      resultsDiv.append(resourcesPagerSection);
      return;
    }
    /* console.log('Applying paging');*/
    const resourcesPagerSection = createCustomElement("div", {
      "class": ["resourcesPagerSection"]
    }, {
      "data-totalrecs": "20",
      "data-pagenum": pagingAmt
    });
    const resPageNav = createCustomElement("button", {
      "class": ["resPageNav", "resPagePrev", "navBtnHidden", "cgConnectBtn"]
    }, {
      "data-pagelow": "0",
      "data-pagedir": "prev"
    }, "Previous");
    const resPageFrom = createCustomElement("span", {
      "class": ["resPageFrom"]
    }, {}, "1");
    const resPageTxt = createCustomElement("span", {
      "class": ["resPageTxt"]
    }, {}, "to ");
    const resPageTo = createCustomElement("span", {
      "class": ["resPageTo"]
    }, {}, pagingAmt);
    const resPageTotal = createCustomElement("span", {
      "class": ["resPageTotal"]
    }, {}, "of " + totalRecords);
    const resPageNav2 = createCustomElement("button", {
      "class": ["resPageNav", "resPageNext", "cgConnectBtn"]
    }, {
      "data-pagedir": "next"
    }, "Next");
    resourcesPagerSection.append(resPageNav, resPageFrom, resPageTxt, resPageTo, resPageTotal, resPageNav2);
    const resourcesPagerSectionClone = resourcesPagerSection.cloneNode(true);
    let citationPagerSection = resultsParent.querySelector(".cgConnectCitPaging");
    let innerResults = resultsDiv.querySelector(".resourcesOutputsInnerWrapper");
    if (citationPagerSection) {
      citationPagerSection.append(resourcesPagerSection);
    } else {
      resultsDiv.prepend(resourcesPagerSection);
    }
    if (innerResults) {
      innerResults.append(resourcesPagerSectionClone);
    } else {
      resultsDiv.append(resourcesPagerSectionClone);
    }
    addPagingListeners(resultsDiv, totalRecords);
    /*********************  Apply initial paging *********************/
    const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");
    records.forEach(function (record, index) {
      record.classList.add("resourceHidden");
      if (index < pagingAmountNum) {
        record.classList.remove("resourceHidden");
      }
    });
  }
  function displayAmountText(resultsDiv, amount = "unknown") {
    const resultsParent = resultsDiv.closest(".dspaceResourcesListBlock");
    if (resultsParent) {
      const displayAmountDiv = resultsParent.querySelector('.numberRecordsDisplay');
      if (displayAmountDiv) {
        displayAmountDiv.textContent = 'Total: ' + amount + ' records';
      }
    }
  }

  /*--------------------------------- Paging listners ---------------------------------*/

  function addPagingListeners(resultsDiv, totalRecords) {
    const pagingNumber = resultsDiv.dataset.pagingnumber;
    const pagingNum = parseInt(pagingNumber);
    let resourcesContainer = resultsDiv.closest(".dspaceResourcesListBlock");
    if (!resourcesContainer) {
      resultsDiv.style.backgroundColor = "greenyellow";
    }
    console.log(`paging number is ${pagingNum}`);
    console.log(`Total records is ${totalRecords}`);
    const pagingNavs = resourcesContainer.querySelectorAll('.resPageNav');
    pagingNavs.forEach(function (pagingNav) {
      pagingNav.addEventListener("click", function (evt) {
        const resBtnPrev = document.querySelectorAll('.resPagePrev');
        const resPageNext = document.querySelectorAll('.resPageNext');
        const padingDir = pagingNav.dataset.pagedir;
        const pagingLowNum = parseInt(resBtnPrev[0].dataset.pagelow);
        let pagingNewLow;
        if (padingDir === "next") {
          pagingNewLow = pagingLowNum + pagingNum;
        } else {
          pagingNewLow = pagingLowNum - pagingNum;
        }
        let pagingNewHigh = pagingNewLow + pagingNum;
        if (pagingNewHigh >= totalRecords) {
          pagingNewHigh = totalRecords;
          resPageNext.forEach(function (resBtnNext12) {
            resBtnNext12.classList.add("navBtnHidden");
          });
        } else {
          resPageNext.forEach(function (resBtnNext12) {
            resBtnNext12.classList.remove("navBtnHidden");
          });
        }
        if (pagingNewLow <= 0) {
          pagingNewLow = 0;
          resBtnPrev.forEach(function (resBtnPrev12) {
            resBtnPrev12.classList.add("navBtnHidden");
          });
        } else {
          resBtnPrev.forEach(function (resBtnPrev12) {
            resBtnPrev12.classList.remove("navBtnHidden");
          });
        }
        resBtnPrev[0].dataset.pagelow = pagingNewLow;
        const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");
        const resourcesPagerSections = resourcesContainer.querySelectorAll('.resourcesPagerSection');
        resourcesPagerSections.forEach(function (resourcesPagerSection) {
          const lowValue = resourcesPagerSection.querySelector('.resPageFrom');
          const highValue = resourcesPagerSection.querySelector('.resPageTo');
          //console.log('The pager sections are');
          //console.log(lowValue);
          lowValue.textContent = pagingNewLow + 1;
          highValue.textContent = pagingNewHigh;
        });
        records.forEach(function (record, index) {
          if (index >= pagingNewLow && index < pagingNewHigh) {
            record.classList.remove("resourceHidden");
          } else {
            record.classList.add("resourceHidden");
          }
        });
        scrollbackTop(resultsDiv);
      });
    });
  }
  function scrollbackTop(el) {
    const backToElm = el.querySelector('div');
    if (backToElm) {
      const yOffset = -200;
      const element = el.querySelector('div');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
      //window.scrollTo({ top: top1, behavior: 'smooth' });
    }
  }

  /*--------------------------------- End Paging listners ---------------------------------*/

  /*----------------------------------------------*/
  /*   Create html element with text            */
  /*----------------------------------------------*/

  function createCustomElement(type, idclasses = [], attributes = [], innerText = "") {
    /* example :  archiveBtn = createCustomElement("button", { "id": "button1", "class": ["ctrlButton", "archiveBtnBtm"]}, {"data-dataid": dataId }); */
    const element = document.createElement(type);
    for (const key in idclasses) {
      if (key == "class") {
        /* classes cannot have spaces when added */
        const className = idclasses[key];
        element.classList.add.apply(element.classList, idclasses[key]); // add all classes at once
      } else {
        element[key] = idclasses[key];
      }
    }
    for (const key2 in attributes) {
      element.setAttribute(key2, attributes[key2]);
    }
    if (innerText != "") {
      element.appendChild(document.createTextNode(innerText));
    }
    return element;
  }

  /*----------------------------------------------*/
  /* Empty the element     */
  /*------------------------------------------*/
  function emptyTheElement(theElement) {
    while (theElement.hasChildNodes()) {
      theElement.removeChild(theElement.firstChild);
    }
  }

  /*-----------------Details buttons -------------------*/
  const publicationsDetails = document.querySelectorAll('.dspaceResourcesListBlock summary.outputDetails, .dspaceResourcesListBlock .dspaceConnectTitle, .dspaceResourcesListBlock .resourceThumb');
  publicationsDetails.forEach(function (pubDetailBtn) {
    pubDetailBtn.addEventListener('click', function (detBtn) {
      let identifier = pubDetailBtn.dataset.identifier;
      let resultsDiv;
      let detailsClicked = new cgConnectourceEvent('dspace_res_details_click', identifier);
      detailsClicked.sendEvent();
    });
  });

  /*--------------- Download Buttons --------------------*/
  const publicationsDLd = document.querySelectorAll('.dspaceResourcesListBlock .resourceDownloadBtn');
  publicationsDLd.forEach(function (pubDldBtn) {
    pubDldBtn.addEventListener('click', function (dldBtn) {
      let identifier = pubDldBtn.dataset.identifier;
      let resultsDiv;
      let downloadClicked = new cgConnectourceEvent('dspace_res_download', identifier);
      downloadClicked.sendEvent();
    });
  });

  /*--------------- Source Buttons --------------------*/
  const publicationsSoruce = document.querySelectorAll('.dspaceResourcesListBlock .cgSp_res_source');
  publicationsSoruce.forEach(function (pubSourceBtn) {
    pubSourceBtn.addEventListener('click', function (dldBtn) {
      let identifier = pubSourceBtn.dataset.identifier;
      let resultsDiv;
      let downloadClicked = new cgConnectourceEvent('dspace_res_source', identifier);
      downloadClicked.sendEvent();
    });
  });
  /*--------------- DOI Buttons --------------------*/
  const publicationsDOIs = document.querySelectorAll('.dspaceResourcesListBlock .cgSp_res_doi');
  publicationsDOIs.forEach(function (pubDOI) {
    pubDOI.addEventListener('click', function (dldBtn) {
      let identifier = pubDOI.dataset.identifier;
      let resultsDiv;
      let downloadClicked = new cgConnectourceEvent('dspace_res_doi', identifier);
      downloadClicked.sendEvent();
    });
  });

  /******************************************************************************************************/
  /*  Events to send to Google Analytics                                                                */
  /*  Example:                                                                                          */
  /*    let detailsClicked = new cgConnectourceEvent('Details clicked', record.handle, resultsDiv);         */
  /*    detailsClicked.sendEvent();                                                                     */
  /******************************************************************************************************/

  function cgConnectourceEvent(evtTitle, handle, resultsDiv, redirectURL = "N/A") {
    const url = new URL(window.location);
    this.handle = handle;
    this.evtTitle = evtTitle;
    this.redirect_url = redirectURL;
    this.url = url;
    this.gid = "G-9ET431M2SQ";
    /* used for reporting... */
    this.resultsDiv = resultsDiv;
  }
  cgConnectourceEvent.prototype.sendEvent = async function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', this.gid, {
      send_page_view: false
    });
    if (this.redirect_url !== "N/A") {
      gtag('event', this.evtTitle, {
        resource_handle: this.handle,
        resource_query: this.url.search,
        resource_redirect: this.redirect_url,
        send_to: this.gid
      });
    } else {
      gtag('event', this.evtTitle, {
        resource_handle: this.handle,
        resource_query: this.url.search,
        send_to: this.gid
      });
    }
    const message = `Type: ${this.evtTitle}, Record:  ${this.handle}, Gid:  ${this.gid},  ${this.url.search !== "" ? ", URL search : " + this.url.search : ""} `;
    console.log(message);
    if (this.resultsDiv) {
      // appendAdminAnalytics(this.resultsDiv, message);
    }
    return true;
  };
  function appendAdminAnalytics(resultsDiv, message) {
    const adminSection = resultsDiv.nextElementSibling;
    if (adminSection) {
      const adminSectionAnalytics = adminSection.querySelector('.admininAnalytics');
      if (adminSectionAnalytics) {
        adminSectionAnalytics.append(createCustomElement("p", {
          "class": ["adminAnalyticsMsg"]
        }, {}, message));
      }
    }
  }
});
/******/ })()
;